import React, { useState, useEffect, useMemo } from 'react';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import './styles.scss';

const ShowMoreLess = ({
  RenderItemComponent,
  data,
  showMoreLabel,
  showLessLabel,
  dataPropName,
  keyProperty,
  showMoreLessButtonClassName,
  showMore,
  setShowMore,
  initialNumberOfItems = 3,
  disableShowMore,
}) => {
  //const [ showMore, setShowMore ] = useState( false );
  const [dataToShow, setDataToShow] = useState(data || []);

  useEffect(() => {
    console.log('10 10 10 10 10 10 10 ', data);
    if (showMore === true) {
      setDataToShow([...data]);
    } else {
      if (data?.length > initialNumberOfItems && showMore === false) {
        setDataToShow([...data].slice(0, initialNumberOfItems));
      } else {
        data && setDataToShow([...data]);
      }
    }
  }, [data]);

  const toggleShowMore = () => {
    setShowMore((val) => {
      if (!val) {
        setDataToShow([...data]);
      } else {
        setDataToShow([...data].slice(0, initialNumberOfItems));
      }

      return !val;
    });
  };

  return data?.length > 0 ? (
    <>
      {dataToShow.map((ele, index) => {
        return (
          <RenderItemComponent
            data={ele}
            index={index}
            key={ele[keyProperty] || index}
            totalItemCount={dataToShow.length}
          />
        );
      })}
      {data.length > initialNumberOfItems && (
        <div
          className={`${
            showMoreLessButtonClassName ? showMoreLessButtonClassName : ''
          } show-more-less mb-3`}
        >
          <GenericButton
            variant="link"
            onClick={!disableShowMore ? toggleShowMore : () => {}}
          >
            {showMore
              ? showLessLabel || 'Show less'
              : `+${data.length - initialNumberOfItems} ${showMoreLabel || ''}`}
          </GenericButton>
        </div>
      )}
    </>
  ) : null;
};

export default React.memo(ShowMoreLess);
